import { DragDropItemTypes } from 'src/utilities/DndConst';
import Draggable from 'react-draggable';
import React, { useContext, useState } from 'react';
import SampleTaskCard from 'src/components/sampleTaskInbox/SampleTaskCard';
import { Col, Modal, Row } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { StoreContext } from 'src/stores/mobx/RootStore';
import { useDrop } from 'react-dnd';

const SampleTaskInbox = ({}) => {
  const sampleTasksStore = useContext(StoreContext).sampleTasks;
  const { notifications } = useContext(StoreContext);
  const [deltaPosition, setDeltaPosition] = useState({ x: 0, y: 0 });

  const getSampleFromItem = (item, itemType) => {
    if (itemType === 'sample') {
      return item.element;
    }
    if (itemType === 'material') {
      return item.material;
    }
  }
  const dropConfig = (required_scan_results = 1) => {
    return {
      accept: [
        DragDropItemTypes.SAMPLE,
        DragDropItemTypes.MATERIAL
      ],
      drop: (item, monitor) => {
        let sample = getSampleFromItem(item, monitor.getItemType())
        let sampleTaskForSampleAlreadyExists = sampleTasksStore.sampleTaskForSample(sample.id);
        if (sampleTaskForSampleAlreadyExists) {
          // create notification
          sendErrorNotification(`Weighing Task for sample id ${sample.id} already exists`);
        } else {
          sampleTasksStore.createSampleTask(sample.id, required_scan_results);
        }
      },
    }
  };
  const [_colProps1, singleScanDropRef] = useDrop(dropConfig(1));
  const [_colProps2, doubleScanDropRef] = useDrop(dropConfig(2));

  if (!sampleTasksStore.inboxVisible) return null;

  const sendErrorNotification = (message) => {
    const notification = {
      title: message,
      message: message,
      level: 'error',
      autoDismiss: 5,
      position: 'tr',
      uid: 'SampleTaskInbox'
    };
    notifications.add(notification);
  }

  const openSampleTaskCount = () => {
    let count = sampleTasksStore.openSampleTaskCount;
    if (count === 0) { return 'no'; }
    return count;
  }

  const openSampleTasks = () => {
    return sampleTasksStore.sortedSampleTasks.map(
      sampleTask => (<SampleTaskCard sampleTask={sampleTask} key={`sampleTask_${sampleTask.id}`} />)
    );
  }

  const sampleDropzone = (dropRef, text, subtext) => {
    return (
      <div className="dnd-zone h-100" ref={dropRef}>
        {text}
        <br />
        {subtext}
      </div>
    );
  };

  const handleDrag = (e, ui) => {
    const { x, y } = deltaPosition;
    setDeltaPosition({
      x: x + ui.deltaX,
      y: y + ui.deltaY,
    });
  }

  return (
    <Draggable handle=".modal-header" onDrag={handleDrag}>
      <div>
        <Modal
          show={true}
          onHide={sampleTasksStore.hideSampleTaskInbox}
          backdrop={false}
          keyboard={false}
          centered
          size="xl"
          className="draggable-modal-dialog"
          dialogClassName="draggable-modal"
          scrollable={true}
          style={{
            transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
          }}
        >
          <Modal.Header className="py-3 border-bottom border-gray-600 bg-gray-300" closeButton>
            <Modal.Title className="handle draggable-modal-stack-title">
              <i
                className="fa fa-refresh me-3"
                aria-hidden="true"
                role="button"
                title="Reload Weighing tasks"
                onClick={sampleTasksStore.load}
              />
              {openSampleTaskCount()} open Weighing Tasks
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="max-vh-60">
            {openSampleTasks()}
            <Row className="align-items-stretch my-3">
              <Col>
                {sampleDropzone(singleScanDropRef, 'Drop Sample to create a Single Scan Task', '(weighing only compound)')}
              </Col>
              <Col>
                {sampleDropzone(doubleScanDropRef, 'Drop Sample to create a Double Scan Task', '(weighing vessel and vessel+compound to calculate difference)')}
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    </Draggable>
  );
}

export default observer(SampleTaskInbox);
